import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import PostService from "../../../api/PostService";
import * as APPCONFIG from "../../../config/app-config.js";
import i18n from "../../../i18n";

import AuthService from "../../../session/AuthService";
class AnnouncementBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      base64String: "",
      image: "",
      feedBack: "",
      iid: this.props.id,
      feedbackState: false,
      feedBackList: [],
      menuState: false,
    };

    this.setFeedBack = this.setFeedBack.bind(this);
  }

 
  componentDidMount() {
  const langValue = AuthService.getCommonLanguages();
  i18n.changeLanguage(langValue);

  this.setState({
    id: this.props.id,
    image: this.props.imgUrl ? this.props.imgUrl : "",
  });

  this.updateFeedbackList(this.props.FeedbackList);
}

componentDidUpdate(prevProps) {
  if (
    prevProps.FeedbackList !== this.props.FeedbackList ||
    prevProps.id !== this.props.id
  ) {
    this.updateFeedbackList(this.props.FeedbackList);
  }
}

updateFeedbackList = (feedbackList) => {
  let feedBack = [];

  if (feedbackList && feedbackList.length > 0) {
    feedBack = feedbackList.filter(
      (data) => String(data.announcementId) === String(this.props.id)
    );
  }

  if (feedBack.length > 0) {
    this.setState({
      feedBackList: feedBack,
    });
  } else {
    this.setState({
      feedBackList: [
        {
          userId: this.props.loginDetails.uId,
          feedBack: "",
          announcementId: this.props.id,
        },
      ],
    });
  }
};

  setFeedBack(FeedBack, id) {
    this.setState({ feedBack: FeedBack }, this.submitFeedBack(id, FeedBack));
  }

  submitFeedBack(id, FeedBack) {
    if (FeedBack !== "") {
      let saveAnnouncementFeedBack = {
        announcementId: id,
        feedBack: FeedBack,
      };

      PostService.saveAnnouncementFeedBack(saveAnnouncementFeedBack)
        .then((response) => {
          var val = [];
          val.push(response.data.data.feedBack);
          this.setState({
            feedBackList: val,
          });
          this.props.UpdateFeedbackList(response.data.data.feedBack);
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (FeedBack === "") {
      toast.warn("Please choose your FeedBack");
    }
  }
  addAnnouncement = (id) => {
    this.props.history.push(
      `/${this.props.workspaceType}/announcement-form/${id}/update-form`
    );
  };
  deleteAnnouncement = (id) => {
    Swal.fire({
      title: "Are you sure to delete this announcement",
      text: "You won't be able to revert this!",
      icon: "warning",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        let data = {
          id: id,
        };
        PostService.deleteAnnouncement(data)
          .then((response) => {
            Swal.fire({
              title: "Deleted Successfully",
              icon: "info",
              type: "info",
              showConfirmButton: true,
            });
            this.props.history.push(`/${this.props.workspaceType}/home`);
          })
          .catch((error) => {
            console.log("error");
            Swal.fire({
              title: "Error in delete",
              icon: "error",
              type: "error",
              showConfirmButton: true,
            });
          });
      }
    });
  };
  handleMenuClick = (event) => {
    this.setState({ menuState: event.target });
  };
  handleMenuClose = (event) => {
    this.setState({ menuState: false });
  };
  render() {

    const { imgUrl, title, content } = this.props;


    return (
      <div className="annoucmentBox image-container">
        <div className="image-container">
          <img
            src={`${APPCONFIG.API_URL}auth/image/${imgUrl}`}
            alt={title}
          />
        </div>
        <div className="announcement-overlay">
          <p className="annoucmentTitle">{title}</p>

          <p
            className="annoucmentContent"
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    workspaceType: state.loginDetailsApi.loginDetails.userWorkSpace?.slug,
    loginDetails: state.loginDetailsApi.loginDetails,
    userRole: state.loginDetailsApi.loginDetails?.userWorkSpace?.role,
    userWorkSpaceId:
      state.loginDetailsApi.loginDetails?.userWorkSpace?.workSpaceId,
  };
};

export default connect(
  mapStateToProps,
  null
)(withTranslation()(withRouter(AnnouncementBox)));
